import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=77795e85&"
import script from "./LightBox.vue?vue&type=script&lang=js&"
export * from "./LightBox.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pexea12/repos/vue-image-lightbox/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77795e85')) {
      api.createRecord('77795e85', component.options)
    } else {
      api.reload('77795e85', component.options)
    }
    module.hot.accept("./LightBox.vue?vue&type=template&id=77795e85&", function () {
      api.rerender('77795e85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LightBox.vue"
export default component.exports